import { t } from "i18next";
import { getLeaveBalance } from "services/leave_report";
import { getHeaders, getURl } from "services/core";
import withDataTable from "components/Report/withDataTable";
import Enum from "common/enums";
import React from "react";
import { Result, Spin } from "antd";

const pathName = "/reports/leaves/employee-leave-balance";

const getLeaveTypeName = (leaveType, value, column) => {
  switch (leaveType) {
      case Enum.LEAVE_TYPE.ANNUAL_LEAVE:
          return `${value} days`;
      case Enum.LEAVE_TYPE.SICK_LEAVE:
          return column === "taken" ? `${value} days` : "";
      case Enum.LEAVE_TYPE.MATERNITY:
          return ["entilement", "taken", "balance"].includes(column) ? `${value} weeks` : "";
      case Enum.LEAVE_TYPE.PATERNITY_LEAVE:
          return ["entilement", "taken", "balance"].includes(column) ? `${value} weeks (x${value})` : "";
      case Enum.LEAVE_TYPE.SPECIAL_LEAVE:
          return ["entilement", "taken", "balance"].includes(column) ? `${value} days` : "";
      case Enum.LEAVE_TYPE.UNPAID_LEAVE:
          return column === "taken" ? `${value} days` : "";
      case Enum.LEAVE_TYPE.COMPENSATION:
          return ["taken", "balance"].includes(column) ? `${value} days` : "";
      case Enum.LEAVE_TYPE.JOB_SEEKING_LEAVE:
          return ["taken", "balance"].includes(column) ? `${value} days` : "";
      default:
          return '';
  }
}


const columns = [
  {
      title: "Leave Type",
      dataIndex: "name",
      key: "name",
      render: (name) => name
  },
  {
      title: "Entitlement",
      dataIndex: "entilement",
      key: "entilement",
      render: (entilement, record) => {
          return getLeaveTypeName(record.type, entilement, "entilement");
      }
  },
  {
      title: "Carry Forward",
      dataIndex: "carryForward",
      height: 60,
      key: "carryForward",
      render: (carryForward, record) => {
          return getLeaveTypeName(record.type, carryForward);
      }
  },
  {
      title: "Additional",
      dataIndex: "additional",
      key: "additional",
      render: (additional, record) => {
          return getLeaveTypeName(record.type, additional, false);
      }
  },
  {
      title: "Taken",
      dataIndex: "taken",
      height: 60,
      key: "taken",
      render: (taken, record) => {
          return getLeaveTypeName(record.type, taken, "taken");
      }
  },
  {
      title: "Balance",
      dataIndex: "leaveBalance",
      key: "leaveBalance",
      render: (leaveBalance, record) => {
          return getLeaveTypeName(record.type, leaveBalance, "balance");
      }
  }
];

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.get("date")) {
    option["date"] = params.get("date");
  }
  if (params.get("employeeId")) {
    option["employeeId"] = params.get("employeeId");
  }
  return getLeaveBalance(option);
};

function getDataSelectSearch(value) {
  if (value) {
    const search = JSON.stringify({
      column: ["name"],
      value: value,
    });
    return fetch(
      `${getURl()}/employee/v1/lists?offset=0&limit=15&search=${search}`,
      {
        headers: getHeaders(),
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((response) =>
        response.data.map((value) => ({
          label: `${value.name}`,
          value: value.id,
        }))
      );
  }
  return [];
}

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] = React.useState(null);
  const params = new URLSearchParams(document.location.search);

  React.useEffect(() => {
    let option = {};
    if (params.get("date")) {
      option["date"] = params.get("date");
    }
    if (params.get("employeeId")) {
      option["employeeId"] = params.get("employeeId");
    }

    option["isExport"] = true;

    getLeaveBalance(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      })
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title="Successfully employee leave balance!"
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}
    </>
  );
}

export default withDataTable({
  title: t("text_leave_report"),
  subTitle: t("text_employee_leave_balance"),
  backLink: "/reports/leaves",
  showFilter: false,
  showExport: true,
  buttonOption: ExportFormLoader,
  onShowSelect: true,
  onShowInputSearch: false,
  pathName,
  columns,
  customEmptyMessage: t("text_please_search_employee"),
  getDataSelectSearch,
  getData,
});
